<template>
  <div ref="container" class="advisors navigation-inset">
    <ElementsHeroHomepage
      :data="{
        title: advisorPage.title ?? '',
        ambigram: advisorPage.ambigram,
        image: advisorPage.image,
        disableRotatingAssetMobile: advisorPage.disableRotatingAssetMobile ?? false,
      }"
    />

    <header class="advisors__header">
      <LayoutGrid>
        <LayoutColumn :l="12">
          <div class="advisors__title-container" :class="{ animate: isInview }">
            <ElementsTitle :data="{ title: advisorPage.title }" color="secondary" />
          </div>
        </LayoutColumn>
      </LayoutGrid>
    </header>

    <ElementsQuickMenusParralaxBg
      :quick-menus="advisorPage.quickMenus[0].quickMenus"
      :clouds-position="cloudsPosition"
      :houses-position="housesPosition"
    />

    <ElementsTabbedContent
      v-if="advisorPage.contentTabs"
      :data="advisorPage.contentTabs"
      @tab-clicked="(distance) => handleTabClick(distance)"
    />

    <ElementsAdvisorContact :data="advisorPage.advisorContactBlock[0]" />

    <div v-if="advisorPage.referenceBlock?.length" class="advisors__reference-cards">
      <ElementsReferenceCardBlock :data="advisorPage.referenceBlock[0]" />
    </div>

    <ElementsRelatedLinksBlock v-if="advisorPage.relatedLinksBlock" :data="advisorPage.relatedLinksBlock" />

    <ElementsAccordion v-if="advisorPage.accordionBlock[0]" :data="advisorPage.accordionBlock[0]" />
  </div>
</template>

<script setup lang="ts">
import { useGlobalStore } from "@/stores/global";
import { storeToRefs } from "pinia";
import { useIntersectionObserver } from "@/composables/useIntersectionObserver";
import ElementsHeroHomepage from "@/components/elements/HeroHomepage.vue";

const observer = ref<IntersectionObserver>();
const container = ref<HTMLElement | null>(null);
const isInview = ref<boolean>(false);

const { content } = storeToRefs(useGlobalStore());

const advisorPage = computed(() => {
  return content.value.data.advisorPage as AdvisorPageRecord;
});

const housesPosition = ref(0);
const cloudsPosition = ref(0);

const handleTabClick = (distance: number) => {
  housesPosition.value += 10 * distance;
  cloudsPosition.value += 20 * distance;
};

const animateIn = () => {
  isInview.value = true;
};

onMounted(() => {
  observer.value = useIntersectionObserver(container.value, animateIn, () => {}, true, { threshold: 0.1 });
});
onUnmounted(() => {
  if (observer.value) {
    observer.value.disconnect();
  }
});
</script>

<style lang="scss">
$component: "advisors";

.#{$component} {
  overflow: hidden;

  &__header {
    text-align: center;
    margin: 100px 0 4rem 0;
  }

  &__title-container {
    @include fadeIn();
  }

  .quick-menus {
    width: 100%;
    padding-bottom: 4rem;
    position: relative;
  }

  &__reference-cards {
    background-color: $color-pale-blue;
    padding-top: 9rem;
    padding-bottom: 10rem;
  }

  @include sm {
    &__reference-cards {
      padding-top: 7rem;
      padding-bottom: 8rem;
    }
  }
}
</style>
